<script setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import Icon from './Icon.vue';
import { DownCircleOutlined } from '@ant-design/icons-vue'
import { useKeyboardStore } from '@/stores/keyboard';
import { loadLanguageAsync } from '@/i18n.js';
const keyboardStore = useKeyboardStore()
const { locale } = useI18n()
const visible = ref(false);
const languageList = [
    { label: 'English', value: 'en' },
    { label: 'Français', value: 'fr' },
    { label: 'Deutsch', value: 'gr' },
    { label: 'Español', value: 'sp' },
    { label: 'Português', value: 'pt' },
    { label: 'Svenska', value: 'sw' },
    { label: 'Русский', value: 'ru' },
    { label: '简体中文', value: 'zh' },
    { label: '日本語', value: 'jp' },
    { label: '한국어', value: 'kr' },
]
const currentLocale = computed(() => {
    return languageList.find(item => item.value === locale.value)?.label || 'Language'
})
const chooseLanguage = async (lang) => {
    // 使用懒加载函数加载语言文件
    await loadLanguageAsync(lang)
    localStorage.setItem('locale', lang)
    const arr = ['fr', 'pt', 'br', 'sp']
    if (arr.includes(lang)) {
        keyboardStore.setLanguage(lang)
    } else {
        keyboardStore.setLanguage('default')
    }
    visible.value = false
}

</script>
<template>
    <div class="rKVPaR">
        <a-popover v-model:open="visible" trigger="click">
            <template #content>
                <div class="language-list">
                    <a v-for="(item, index) in languageList" :key="index" @click="chooseLanguage(item.value)">{{
                        item.label }}</a>
                    <!-- <a @click="chooseLanguage('en')">English</a> -->
                </div>
            </template>
            <div class="nav-button-content pointer">
                <span class="sc-hvigdm sc-fhHczv bDNdxN kTbYFY ">{{
                    currentLocale
                    }}</span>
                <div style="display: flex;">
                    <DownCircleOutlined />
                </div>
            </div>
        </a-popover>
    </div>
</template>
<style lang="scss" scoped>
.language-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    // padding: 0.5rem 1rem;

    a {
        cursor: pointer;
        color: var(--text-black-l-title);

        &:hover {
            // color: var(--button-blue-l);
            background-color: var(--button-black-xs-min);
        }
    }
}

.nav-button-content {
    // justify-content: flex-start;
    flex: none;
}
</style>